import { getText } from 'misc/helpers';

export const required = value => (value ? undefined : 'Obligatorisk');
export const maxLength = max => value => (value && value.length > max ? `Måste vara högst ${max} tecken` : undefined);
export const minLength = min => value => (value && value.length < min ? `Måste vara minst ${min} tecken` : undefined);
export const exactLength = minMax => value => (value && value.length !== minMax ? `Måste vara exakt ${minMax} tecken` : undefined);
export const isNumber = value => (/\D/g.test(value) ? getText('Missing', 'Vänligen ange endast siffror') : undefined);
export const phone = value =>
    /^\+?([0-9]{2})\)?[0-9-]+$/i.test(value) || value === undefined || value === ''
        ? undefined
        : getText('Missing', 'Felaktigt mobilnummer');
export const email = value =>
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? getText('Missing', 'Felaktig E-post') : undefined;
export const personnr = value => (!/^[0-9]+$/i.test(value) && value !== '' ? getText('Missing', 'Felaktigt personnummer') : undefined);

/*
export const normalizePhone = (value, previousValue) => {
    if (!value) {
        return value;
    }
    const onlyNums = value.replace(/[^\d]/g, '');
    if (!previousValue || value.length > previousValue.length) {
        // typing forward
        if (onlyNums.length === 3) {
            return onlyNums + '-';
        }
    }
    if (onlyNums.length <= 3) {
        return onlyNums;
    }
    if (onlyNums.length <= 6) {
        return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3);
    }
    return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3, 6) + '-' + onlyNums.slice(6, 10);
};
*/



// WEBPACK FOOTER //
// ./src/misc/validations.js